import { useAuth } from '@contexts/auth-provider';
import * as React from 'react';

import type { HeapIdentity } from '../../heapIdentity.types';

import { buildHeapContext } from './useHeap.utils';

/**
 * Returns a memoized HeapIdentity for passing to MFEs, or null when the user
 * is not yet authenticated. The context is stable across re-renders as long
 * as authData does not change.
 */
export function useHeap(): HeapIdentity | null {
  const { authData } = useAuth();

  return React.useMemo(() => {
    if (!authData) return null;
    return buildHeapContext();
  }, [authData]);
}
